import { render, staticRenderFns } from "./YesNo.vue?vue&type=template&id=2cb43154&scoped=true"
import script from "./YesNo.vue?vue&type=script&lang=js"
export * from "./YesNo.vue?vue&type=script&lang=js"
import style0 from "./YesNo.vue?vue&type=style&index=0&id=2cb43154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb43154",
  null
  
)

export default component.exports